import { Children, useEffect } from "react";
import { ReactComponent as QuestionIcon } from "../assets/question.svg";
import get_token from "../lib/get_token";
import axios from "axios";
import { configState } from "../lib/State";
import get_cid from "../lib/get_cid";
import { forwardRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  alertTitleClasses,
  Box,
  Dialog,
  Divider,
  Slide,
  Tab,
  Tabs,
} from "@mui/material";
import Swal from "sweetalert2";
import pr from "../lib/pr";
import HomeHelpHeartPoint from "./HomeHelpHeartPoint";
import ModalComp from "./ModalComp";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const icon100 = {
  empty: <img src="/img/heart_point/cash_100_empty.png"></img>,
  active: <img src="/img/heart_point/cash_100_active.png"></img>,
  done: <img src="/img/heart_point/cash_100_done.png"></img>,
};

const icon500 = {
  empty: <img src="/img/heart_point/cash_500_empty.png"></img>,
  active: <img src="/img/heart_point/cash_500_active.png"></img>,
  done: <img src="/img/heart_point/cash_500_done.png"></img>,
};

// 심박포인트
export default ({ login, action, children }) => {
  const token = get_token();
  const cid = get_cid();
  const history = useHistory();
  const [rows, setRows] = useState([]);
  const [mb_name, setMbName] = useState("");
  const [hp, setHp] = useState(0); // 심박포인트
  const [p10000, setP10000] = useState(0); // 만포인트 획득
  const [page, setPage] = useState(0); // 40개씩 페이지
  const [totalPage, setTotalPage] = useState(0);

  // 캐시 받기
  const get_cash = async (id) => {
    Swal.fire({
      background: "transparent",
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });
    const result = await axios.post(
      `${configState.api}/gympass/home_get_cash`,
      {
        token: token,
        cid: cid,
        mcd: login.mcd,
        level: login.level,
        point: id,
      }
    );
    if (!result?.data?.success)
      return Swal.fire(
        "알림",
        "적립에 실패했습니다. 다시 시도해주세요. 지속적으로 발생할 시 문의를 이용해주세요.",
        "error"
      );
    Swal.fire({
      title: "알림",
      text: `${id} 캐시가 적립되었습니다.`,
      icon: "success",
      didOpen: () => {
        get_list_point();
        // axios.post(configState.api + "/push/to_mcd", {
        //   cid: cid,
        //   mcd: login.mcd,
        //   title: "캐시",
        //   message: `${id}캐시가 적립되었습니다.`,
        // });
      },
    });
  };

  // 아이콘 결정
  const get_icon = (id, row) => {
    let icon = null;
    if (id === "100") {
      icon = icon100.empty;
      if (row.complete === "Y") {
        // 완료
        if (row.c100 === "N") {
          // 캐시 안받음
          icon = (
            <div className="active:animate-ping" onClick={() => get_cash(id)}>
              {icon100.active}
            </div>
          );
        } else if (row.c100 === "none") {
          icon = icon100.empty;
        } else {
          icon = icon100.done;
        }
      }
    } else if (id === "500") {
      icon = icon500.empty;

      if (row.complete === "Y") {
        if (row.c500 === "N") {
          icon = (
            <div className="active:animate-ping" onClick={() => get_cash(id)}>
              {icon500.active}
            </div>
          );
        } else if (row.c500 === "none") {
          icon = icon500.empty;
        } else {
          icon = icon500.done;
        }
      }
    }
    return icon;
  };

  // 회원이름
  const get_mb_name = async () => {
    let result = await axios.post(configState.api + "/gympass/get_member_one", {
      token: token,
      cid: cid,
      mcd: login.mcd,
      level: login.level,
    });
    if (result.data?.member?.name) {
      setMbName(result.data?.member?.name);
    }
  };

  // 총 포인트
  const get_total_point = async () => {
    let result = await axios.post(
      configState.api + "/gympass/home_total_point",
      {
        token: token,
        cid: cid,
        mcd: login.mcd,
        level: login.level,
        type: "심박포인트",
      }
    );
    setHp(result.data.amount);

    // TEST
    // setHp(13000);

    // 페이지 설정
    let i = result.data.amount;
    if (i > 0) {
      i = Math.ceil(i / 40 / 100) - 1;
      if (i == 1 || i == 2) setPage(i);
    }
  };

  // 리스트 포인트
  const get_list_point = async () => {
    let result = await axios.post(
      configState.api + "/gympass/home_list_point",
      {
        token: token,
        cid: cid,
        mcd: login.mcd,
        level: login.level,
        type: "심박포인트",
      }
    );

    setP10000(result.data.p10000);

    if (!result.data.p100) return;
    // 40 개 당 한페이지
    const heartPointTototalPage = Math.ceil(hp / 4000);

    setTotalPage(heartPointTototalPage);
    setPage(heartPointTototalPage - 1);

    let i, j, k, id, complete, c100, c500;
    k = 0;
    id = 0;
    let items = [];
    const p100Data = result.data.p100;
    const p500Data = result.data.p500;

    for (i = 0; i < 8 * heartPointTototalPage; i++) {
      items[i] = [];
      for (j = 0; j < 5; j++) {
        id = (k + 1) * 100;
        complete = id <= hp ? "Y" : "N"; // 포인트 획득 유무
        c100 = "N";
        c500 = "none";
        if (complete === "Y") {
          c100 =
            p100Data[id] === undefined
              ? "none"
              : p100Data[id] === 0
              ? "N"
              : "Y"; // 캐시 안받음 N
          c500 =
            p500Data[id] === undefined
              ? "none"
              : p500Data[id] === 0
              ? "N"
              : "Y"; // 캐시 안받음 N
        }
        items[i].push({
          id: id,
          complete: complete,
          c100: c100,
          c500: c500,
        });
        k++;
      }
    }
    setRows(items);
  };

  useEffect(() => {
    if (login?.mcd) {
      get_total_point();
    }
  }, [login]);

  useEffect(() => {
    get_mb_name();
    get_total_point();
    get_list_point();
  }, [hp]);

  return (
    <>
      <div
        className={
          action !== "more"
            ? "text-6xl font-light w-full border-r relative"
            : null
        }
      >
        {action !== "more" && (
          <div className="absolute right-[12px]">
            <HomeHelpHeartPoint>
              <QuestionIcon className="w-[16px]" />
            </HomeHelpHeartPoint>
          </div>
        )}

        <ModalComp
          title="심박포인트"
          button={
            action === "more" ? (
              <div>{children}</div>
            ) : (
              <div
                className="mt-[5px] text-[#0092a2] text-[28px] flex justify-center"
                style={{ fontFamily: "BebasNeue" }}
              >
                <div className="px-2">{hp ? hp : 0}</div>
              </div>
            )
          }
          login={login.mcd}
          afterOpenMethod={() => {
            get_mb_name();
            get_total_point();
            get_list_point();
          }}
        >
          <div className="bg-[#0acfd5] pt-5 shadow-inner">
            <div className="pl-5 text-white font-bold text-lg">
              안녕하세요, {mb_name}님
            </div>
            <div className="text-sm mt-4 ml-2 pl-6 pr-6">
              <span className="text-white font-bold">
                운동 중 심박포인트 미션이
              </span>
              <span className="text-[#007e82] font-bold ml-1">
                100포인트에 도달
              </span>
              <span className="text-white font-bold">하면</span>
              <span className="text-[#007e82] font-bold ml-1">
                스탬프가 지급
              </span>
              <span className="text-white font-bold">되며</span>
              <span className="text-[#007e82] font-bold ml-1">
                스탬프를 터치하면
              </span>
              <span className="text-[#fffc00] font-bold ml-1">캐시를 지급</span>
              <span className="text-[#007e82] font-bold ml-1">
                받을 수 있습니다. <br></br>10,000포인트는 12,000 심박포인트 마다
                지급 받을 수 있으며 3회 까지만 제공됩니다.
              </span>
            </div>
            <div className="flex justify-center mt-5">
              <HomeHelpHeartPoint>
                <div className="font-bold text-sm text-white border-2 py-2 px-4 rounded-md border-white active:bg-red-300 ">
                  심박포인트 캐시 적립방법 자세히 보기
                </div>
              </HomeHelpHeartPoint>
            </div>

            <div className="flex justify-center mt-3 items-center">
              <div className="text-white font-bold pr-[5px] pt-[40px]">
                Total
              </div>
              <div className="relative pr-4">
                <div className="flex">
                  <div className="absolute bottom-4 right-0 text-red-500 text-sm bg-white font-bold rounded-sm min-w-[35px] text-center">
                    {hp > 0 ? hp / 100 : 0}
                  </div>
                </div>
                <img src="/img/heart_point/icon1.png"></img>
              </div>
            </div>
            <div className="h-5"></div>
          </div>

          {/* 본문 */}
          <div className="bg-[url('/img/heart_point/bg.png')] bg-cover">
            <div className="pt-8 flex justify-center">
              <img src="/img/heart_point/title.png"></img>
            </div>

            {/* 선반 A */}
            <div className="relative mt-5">
              <div className="absolute bottom-0 w-full flex justify-center">
                <img src="/img/heart_point/shelf.png"></img>
              </div>
              <div className="relative flex justify-center pb-8 items-end">
                {p10000 &&
                  Array.from({ length: 3 }).map((_, index) => (
                    <div className="ml-2" key={index}>
                      {p10000[index] === undefined && (
                        <img src="/img/heart_point/cash2_off.png" />
                      )}
                      {p10000[index] == 10000 && (
                        <img src="/img/heart_point/cash2_done.png" />
                      )}
                      {p10000[index] == 0 && (
                        <img
                          src="/img/heart_point/cash2_active.png"
                          onClick={() => {
                            get_cash(10000);
                          }}
                        />
                      )}
                    </div>
                  ))}
              </div>
            </div>

            <Tabs
              value={page}
              onChange={(_, newPage) => setPage(newPage)}
              className="mt-3 mb-10"
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              sx={{
                "& .MuiTabs-scrollButtons.Mui-disabled": {
                  opacity: 0.2,
                },
                "& .MuiTabScrollButton-root": {
                  width: "20px",
                },
                border: "1px solid rgba(0,0,0,0.2)",
                borderLeft: "0px",
                borderRight: "0px",
              }}
            >
              {Array.from({ length: totalPage }).map((_, index) => (
                <Tab
                  key={index}
                  value={index}
                  label={+index + 1}
                  sx={{
                    minWidth: 0,
                  }}
                />
              ))}
            </Tabs>

            {/* 선반 B */}
            {rows.map((item, index) => {
              const start = page * 8;
              const end = start + 8;

              if (index >= start && index < end) {
                return (
                  <div className="relative -mt-[20px]" key={index}>
                    <div className="absolute bottom-0 w-full flex justify-center">
                      <img src="/img/heart_point/shelf.png"></img>
                    </div>
                    <div className="relative flex justify-center pb-9 items-end">
                      <div>{get_icon("100", item[0])}</div>
                      <div>{get_icon("100", item[1])}</div>
                      <div>{get_icon("100", item[2])}</div>
                      <div>{get_icon("100", item[3])}</div>
                      <div>{get_icon("100", item[4])}</div>
                      <div className="pb-5">
                        <img src="/img/heart_point/plus.png"></img>
                      </div>
                      <div>{get_icon("500", item[4])}</div>
                    </div>
                  </div>
                );
              }
            })}
            <div className="h-10"></div>
          </div>
        </ModalComp>

        {action !== "more" && (
          <div className="mt-[13px] text-[14px] font-bold">심박포인트</div>
        )}
      </div>
    </>
  );
};
